'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package
 * @restrict E
 *
 * @description
 * #directive
 * Base component to init the tv package selector
 *
 * @template:'<div class="v-tv-package" data-ng-class="{\'package-only\': $ctrl.bundledChannels}"><div class="tv-package-loader" data-ng-class="{\'active\': $ctrl.isApiLoading()}"></div><section class="row main-content"><div class="row" data-ng-if="$ctrl.serviceUnavailable"><div class="v-generic-message-information"><h3 data-translate="ERROR.SERVICE_UNAVAILABLE.TITLE"></h3><p data-translate="ERROR.SERVICE_UNAVAILABLE.DESCRIPTION"></p></div></div><div class="pull-left channels-column" data-ng-if="!$ctrl.serviceUnavailable" data-ng-class="{\'channels-column-full\': $ctrl.bundledChannels}"><form name="tv-package"><div><h2 data-translate="TITLE"></h2><p ng-if="$ctrl.availableBaseHdTab() && $ctrl.selectionInitDone && !$ctrl.bundledChannels" data-translate="INTRO"></p></div><v-tv-package-channels data-channels-list="$ctrl.channelsByCategories" data-bundled-channels="$scope.$parent.$ctrl.bundledChannels" data-package-instance-id="{{$ctrl.packageInstanceId}}"><v-tv-package-filters data-show-filter="!$scope.$parent.$ctrl.bundledChannels" data-ng-class="{\'no-filters\': $ctrl.bundledChannels}"></v-tv-package-filters></v-tv-package-channels></form></div><aside class="pull-right cart-panels" data-ng-if="!$ctrl.serviceUnavailable && !$ctrl.bundledChannels"><form name="tv-package-cart" novalidate data-ng-submit="$ctrl.preventSubmit($event)"><v-tv-package-cart-state></v-tv-package-cart-state></form></aside></section></div>'
 * @param {string} package The id of the package to load
 * @param {string} domain The domain for which we are loading the package. Either ```residential``` or ```business``
 * @param {boolean=false} useAuthenticatedMode Not used for now. Should be implemented when the module
 * is used in the customer center page.
 * @param {boolean=false} aLaCarteMode Not implemented yet. If true, show the cart as à la carte on initialization
 * @param {boolean=false} canSelectALaCarte Not implemented yet. Defines if the module can switch between à la carte
 * and package cart.
 */

angular.module('v-tv-package').component('vTvPackage', {
    bindings: {
        package: '@',
        useAuthenticatedMode: '@',
        domain: '@',
        aLaCarteMode: '@',
        canSelectALaCarte: '@',
        bundledChannels: '@',
        packageInstanceId: '@'
    },
    template:'<div class="v-tv-package" data-ng-class="{\'package-only\': $ctrl.bundledChannels}"><div class="tv-package-loader" data-ng-class="{\'active\': $ctrl.isApiLoading()}"></div><section class="row main-content"><div class="row" data-ng-if="$ctrl.serviceUnavailable"><div class="v-generic-message-information"><h3 data-translate="ERROR.SERVICE_UNAVAILABLE.TITLE"></h3><p data-translate="ERROR.SERVICE_UNAVAILABLE.DESCRIPTION"></p></div></div><div class="pull-left channels-column" data-ng-if="!$ctrl.serviceUnavailable" data-ng-class="{\'channels-column-full\': $ctrl.bundledChannels}"><form name="tv-package"><div><h2 data-translate="TITLE"></h2><p ng-if="$ctrl.availableBaseHdTab() && $ctrl.selectionInitDone && !$ctrl.bundledChannels" data-translate="INTRO"></p></div><v-tv-package-channels data-channels-list="$ctrl.channelsByCategories" data-bundled-channels="$scope.$parent.$ctrl.bundledChannels" data-package-instance-id="{{$ctrl.packageInstanceId}}"><v-tv-package-filters data-show-filter="!$scope.$parent.$ctrl.bundledChannels" data-ng-class="{\'no-filters\': $ctrl.bundledChannels}"></v-tv-package-filters></v-tv-package-channels></form></div><aside class="pull-right cart-panels" data-ng-if="!$ctrl.serviceUnavailable && !$ctrl.bundledChannels"><form name="tv-package-cart" novalidate data-ng-submit="$ctrl.preventSubmit($event)"><v-tv-package-cart-state></v-tv-package-cart-state></form></aside></section></div>',
    controller: function controller($injector, TvPackageSelectionStateService, TvPackageChannelsByCategories, TvPackageApi, $document, $element) {
        var _this = this;

        this.selectionInitDone = false;
        this.cartIsDisabled = true;
        this.useAuthenticatedMode = this.useAuthenticatedMode && this.useAuthenticatedMode !== 'false' || false;
        this.canSelectALaCarte = this.canSelectALaCarte && this.canSelectALaCarte !== 'false' || true;
        this.bundledChannels = this.bundledChannels && this.bundledChannels === 'true' || false;
        this.packageInstanceId = this.packageInstanceId || '_v_tv_package_' + new Date().getTime();

        $element.attr('data-package-instance-id', this.packageInstanceId);

        //this.canSelectALaCarte must be true to be able to set aLaCarteMode to true
        this.aLaCarteMode = this.aLaCarteMode && this.aLaCarteMode !== 'false' && this.canSelectALaCarte || false;

        this.preventSubmit = function ($event) {
            $event.preventDefault();
            return false;
        };

        this.availableBaseHdTab = function () {
            return !!$document[0].getElementById('tab/base-HD');
        };

        if (angular.isDefined(this.package)) {
            TvPackageSelectionStateService.setSelectedPackageId(this.package);
        } else {
            this.package = null;
        }

        TvPackageSelectionStateService.setDomain(this.domain);
        TvPackageSelectionStateService.setAuthenticatedMode(this.useAuthenticatedMode);
        TvPackageSelectionStateService.canSelectALaCarte(this.canSelectALaCarte);

        TvPackageSelectionStateService.addStore($injector.get('TvPackageLocalStorageStoreService'));

        if (this.useAuthenticatedMode) {
            TvPackageSelectionStateService.addStore($injector.get('TvPackageUserAccountStoreService'));
        }

        this.isApiLoading = TvPackageApi.isTrackingActive;

        TvPackageChannelsByCategories.getChannelsByCategories(this.bundledChannels).then(function (channelsByCategories) {
            _this.channelsByCategories = channelsByCategories;
            return _this.channelsByCategories;
        }, function () {
            _this.serviceUnavailable = true;
            return _this.serviceUnavailable;
        });

        TvPackageSelectionStateService.setALaCarte(this.aLaCarteMode).then(function () {
            return TvPackageSelectionStateService.getSelectionState().finally(function () {

                _this.cartIsDisabled = TvPackageSelectionStateService.getActiveCart().getIsDisabled();
                _this.selectionInitDone = true;
            });
        });
    }
});